import WebConnexIntegrationPage from '@/pages/integrations/webconnex/WebConnexIntegrationPage.vue'
import HomePageLayout from '@/layouts/HomePageLayout.vue'
import BackendPages from '@/layouts/BackendPages.vue'
import WebConnexIntegrationSuccessPage from '@/pages/integrations/webconnex/WebConnexIntegrationSuccessPage.vue'

export default [
  { path: '/integrations/webconnex/supporter', name: 'WebConnexIntegration', component: WebConnexIntegrationPage, meta: { requiresAuth: true, layout: BackendPages } },
  // the user arrives here after a successful OAUTH2 flow integration setup on webconnex side, after we got the apikey and shoved it into our system
  { path: '/integrations/webconnex/success', name: 'WebConnexIntegrationSuccess', component: WebConnexIntegrationSuccessPage, meta: { requiresAuth: true, layout: BackendPages } },
]


